var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('about_me')))]),(_vm.loading)?_c('div',{staticClass:"text-tertiary text-sm"},[_vm._v("Loading...")]):_c('div',{staticClass:"about-content markdown-body",domProps:{"innerHTML":_vm._s(_vm.renderedContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }